export const SUPPORTED_LANGUAGES = ['ja', 'en'];

const MESSAGES = {
  ja: {
    app: {
      devBanner: '開発環境 (preview)',
    },
    header: {
      toPurpose: '目的ベースへ',
      toGraph: '人通りデータへ',
      graphDashboard: '人通りデータ',
      dashboardLogoAlt: '高山市AIカメラデータダッシュボード（目的ベース）のロゴ',
      dashboardLogoAria: 'ダッシュボードロゴ',
      toggleConditions: '条件パネルの表示切り替え',
      switchToJa: '日本語表示に切り替え',
      switchToEn: '英語表示に切り替え',
      purposePrompt: 'やりたいことは...',
      functionPrompt: '見たいグラフは...',
      emptySelection: '未入力',
      dataYearMonth: 'データの年・月',
      dataYear: 'データの年',
      previousMonth: '前の月',
      nextMonth: '次の月',
      selectYear: '年を選択',
      selectMonth: '月を選択',
      yearPlaceholder: '----年',
      monthPlaceholder: '--月',
      yearSuffix: '年',
      monthSuffix: '月',
      locationLabel: '計測場所',
      selectLocation: '計測場所を選択',
      locationEmpty: '場所未選択',
      cameraPlacementButton: 'カメラの設置場所',
      cameraImageAlt: 'カメラの設置場所',
      closeModal: '閉じる',
    },
    share: {
      title: 'ダッシュボード共有',
      text: '{year}年{month}月の{location}データ',
      button: '共有',
      tooltipNoData: 'データが選択されていません',
      tooltipCopy: 'URLをコピー',
      copied: 'URLをクリップボードにコピーしました',
    },
    aiPrompt: {
      sectionTitle: '生成AIコーナー',
      sectionLead:
        'この画面のデータと地域の文脈を短くまとめた文章を作れます。コピーしてお使いの生成AIに貼り付け、埋め込み情報を土台にしつつ必要ならウェブで高山の公式情報なども参照させ、データの読み方や次の一歩が分かるように対話してもらう使い方を想定しています。',
      openButton: 'プロンプトを作成・コピー',
      modalTitle: '生成AIへの相談用',
      modalIntro:
        'いま画面に出ているグラフの内容と、この地域ならではの前提を、読みやすい一続きの文章にまとめました。普段お使いの生成AIに貼り付け、必要ならウェブで高山の公式情報などを調べつつ、データの意味や限界が少しずつ分かるように話してもらう土台として使ってみてください。気になるところがあれば、コピーする前にこの中から直接書き換えていただいて大丈夫です。',
      copyAreaExplain: '「この文章をコピー」を押すと、下の欄の文字がすべて一度にコピーされます。',
      copy: 'この文章をコピー',
      promptAriaLabel: '相談用にまとめた文章',
      copied: 'クリップボードにコピーしました',
      copyFailed: 'コピーに失敗しました',
      unsupported: 'この画面ではまだ利用できません。',
    },
    today: {
      overview: '{date} の概要',
      todayLabel: '今日',
      todayData: '今日のデータ',
      noData: 'データはまだ利用できません',
      weekend: '休日',
      weekday: '平日',
      congestionLevel: '混雑レベル {level}',
      weekdaySuffix: '曜日',
    },
    common: {
      fetchError: 'データの取得に失敗しました',
      loadingData: 'データを読み込み中...',
      selectLocationFirst: 'まず計測場所を選択してください',
    },
    legend: {
      titleCalendar: '混雑度の凡例（上：日付、下：混雑度）:',
      titleDefault: '混雑度の凡例:',
      peopleAmount: '人の量の見方',
      readGuideLead: '数字が大きいほど、人が多い目安です',
      bandLow: '少ない',
      bandMid: '普通',
      bandHigh: '多い',
      bandRange: '{from}〜{to}',
      dayLabel: '日にち',
      noData: 'データなし',
      calcNote: '※ 歩行者が1人以上いる時間帯のデータのみで平均値を計算しています',
      weatherInfo: '天気情報:',
      weatherPlacement: '各セルの下部に表示',
    },
    todayDetails: {
      titleSuffix: 'の混雑状況',
      thisYear: '今年',
      lastYear: '去年',
    },
    adminThresholds: {
      title: '閾値管理',
      back: 'ダッシュボードへ',
      uiJa: '日本語で表示',
      uiEn: '英語で表示',
      showSlug: '場所コード表示',
      layoutOverview: '全地点を見比べる',
      layoutFocus: '1地点をくわしく見る',
      secretLabel: '管理者キー',
      authBtn: '管理者キーを入力',
      reauthBtn: '管理者キーを変更',
      authed: '認証済み',
      needAuth: '先に管理者キーを入力してください',
      loadBtn: '閾値を読み込み',
      reloadBtn: '閾値を再読み込み',
      dateLabel: '比較する日',
      monthLabel: '比較する月',
      monthDayLabel: '月内の比較日',
      actionGroupLabel: 'グラフ種別',
      seedBtn: 'デフォルトの値に再設定',
      seedBtnHelp: '選択中のグラフ種別について、未設定の地点を組み込み既定値で埋めます',
      seedConfirmMissing: '「{group}」で未設定の地点を、デフォルトの値に再設定しますか？',
      seedConfirmOverwrite: '「{group}」の全地点をデフォルトの値で上書きしますか？',
      seedOk: '再設定完了 新規{created} / 更新{updated} / スキップ{skipped}',
      builtinHint: '組込 {min}–{max}',
      applyBuiltin: '組込を入力',
      batchBtn: '予測を再計算（{n}地点）',
      batchAllBtn: '全地点を再計算',
      batchRunning: '予測計算中…',
      batchBtnHelp: '「予測（dti共通）」の閾値保存後、バッチで人数予測を再生成します（表示の混雑度は保存だけで dti/API に即反映）。',
      batchAllBtnHelp: '全計測地点の予測を再生成します（時間がかかります）',
      batchNoTargets: '再計算対象がありません。「予測」の閾値を保存するか、予測グループで未保存の変更がある地点を選んでください。',
      batchConfirmChanged:
        '次の{n}地点の予測のみ再計算します。\n{places}\n\n実行しますか？',
      batchConfirmAll:
        '全地点の予測バッチを実行します。\n・数分かかることがあります\n・完了後、右のプレビューが自動で更新されます\n\n実行しますか？',
      batchStarted: '{n}地点の予測バッチを開始しました（{batchId}）',
      batchDone: '予測バッチ完了: 成功{ok}地点 / 失敗{fail}地点（全{total}）',
      previewLoading: 'プレビュー取得中…',
      previewStatus: '取得 {ok}地点・失敗{fail}',
      stripCurrent: '混雑度プレビュー（現在の閾値）',
      stripBeforeEdit: '編集前（現在の本番）',
      stripAfterEdit: '編集後（保存すると反映）',
      compareHintShort: '閾値 {before} → {after} に変更中の比較です。',
      previewThresholdRange: '（閾値 {range}）',
      chartCurrent: '現在',
      chartBeforeEdit: '編集前',
      chartAfterEdit: '編集後',
      unsaved: '未保存',
      hintShort:
        'ログイン後、閾値・日付を変えるとプレビューは自動更新されます。編集→保存で本番に反映されます。',
      listTitle: '一覧',
      placesUnit: ' 地点',
      placeCol: '計測場所',
      minPeople: '下限（人数）',
      midPeople: '中央（任意・入力時はビン境界に使用）',
      maxPeople: '上限（人数）',
      dbCol: 'DB',
      save: '保存',
      history: '履歴',
      memoLabel: '保存メモ（共通・任意）',
      miniLineTitle: 'ミニ折線（全地点）',
      previewPlace: '詳細プレビュー地点',
      emptyHint: '管理者キー入力後に「閾値を読み込み」',
      emptyFetchHint: '閾値を読み込むとプレビューが自動表示されます',
      emptyDetailHint: '地点を選び全日取得後に表示',
      previewTitle: '本番UI相当（HourlyCell・7–22時）',
      apiHeatRow: 'ヒートマップ型（時間軸）',
      draftHeatRow: 'ヒートマップ型（時間軸・編集後）',
      expandedLineTitle: '折線（拡大・同一地点）',
      chartApi: '公開API',
      chartDraft: '入力プレビュー',
      historyTitle: '履歴',
      close: '閉じる',
      apply: '反映',
      noneHistory: 'なし',
      errMinMax: '下限・上限は数値で入力してください',
      errMinMaxNamed: '{min}・{max}は数値で入力してください',
      errOrder: '下限は上限より小さい必要があります',
      errOrderNamed: '{min}は{max}より小さくしてください',
      errMiddle: '中央は下限〜上限の間である必要があります',
      errMiddleNamed: '{mid}は{min}〜{max}の間である必要があります',
      loadedOk: '閾値読込 {n}地点',
      savedOk: '{place} を保存',
      fetchOk: '取得完了 OK {ok} / NG {fail}（{label}）',
      batchOk: 'バッチ完了 NG {ng}/{total}',
      historyApplied: '履歴#{id} → {place} に反映（保存で確定）',
      noPrediction: '予測なし',
      matrixTitle: '地点別・グラフ別の閾値一覧',
      viewMatrix: '一覧',
      viewEdit: '編集',
      editPanelTitle: '編集中のグラフ種別',
      editPanelOpenGroup: 'ヘッダーの「グラフ種別」で切り替えできます',
      matrixEditBtn: '編集',
      reloadMatrix: 'マトリクス再読込',
      matrixEmpty: '認証後にマトリクスを読み込んでください',
      matrixCellDb: 'DB: {min}–{max}',
      matrixCellFallback: '実効（{group}経由）: {min}–{max}',
      matrixCellBuiltin: '組込: {min}–{max}',
      dbCurrentCol: 'DB現在値',
      dbNotSet: '未設定',
      viaFallback: 'フォールバック',
      editingGroup: '編集中: {group}',
      previewDateFallback: '表示日: {date}（選択日にデータが無いため）',
      previewNotFetched: '閾値を読み込むか、予測データが無い場合は「予測を再計算」を実行してください',
      graphTypeCol: 'グラフ種別',
      thresholdRangeCol: '最小〜最大',
      builtinShort: '組込',
      loginBtn: '管理者ログイン',
      loginApply: 'ログイン',
      logoutBtn: 'ログアウト',
      previewUsesPrediction:
        '右のプレビューは予測APIの時間別表示です（dti_* と同じ heatmap_date_time 閾値）。保存後は本番ダッシュボード・API に即反映されます。',
      previewUsesProduction:
        '右のプレビューは本番ダッシュボードと同じグラフ（/api/get-graph）です。選択中のグラフ種別の閾値が反映されます。',
      previewProductionTitle: '本番プレビュー: {group}',
      previewOverviewProductionHint: '一覧のミニグラフは「予測」編集時のみ。他の種別は下の詳細プレビューを参照してください。',
      matrixHint: '地点名を開くとグラフ別の閾値を表示。行の「編集」から入力画面へ。右のプレビュー地点も連動します。',
      splitDragHint: '境界をドラッグして幅を調整',
    },
    footer: {
      noticeTitle: 'データ利用に関する注意事項',
      noticeLeadBefore: '※本ページは、高山市のオープンデータ(',
      noticeLeadLink: 'まちなかにおける観光通行量調査データ',
      noticeLeadConnector: '、',
      noticeLeadLinkForeigners: '外国人観光客宿泊統計',
      noticeLeadAfter: ')から作成しています。本ページを参考にしたいかなる損失も、責任は負いかねます。',
      noticeBody: 'データは自動的にカメラで取得したものであるので、実際の状況と異なる場合があります。最新かつ正確な情報は、各公式サイトや施設にて直接ご確認ください。',
      noticeTermsBefore: '詳細は',
      noticeTermsLink: '利用規約・プライバシーポリシー',
      noticeTermsAfter: 'をご覧ください。',
    },
  },
  en: {
    app: {
      devBanner: 'Development Environment (preview)',
    },
    header: {
      toPurpose: 'Action-First',
      toGraph: 'Pedestrian Data',
      graphDashboard: 'Pedestrian Data',
      dashboardLogoAlt: 'Takayama AI Camera Dashboard logo (Action-First)',
      dashboardLogoAria: 'Dashboard logo',
      toggleConditions: 'Toggle filter panel',
      switchToJa: 'Switch to Japanese',
      switchToEn: 'Switch to English',
      purposePrompt: 'What do you want to do?',
      functionPrompt: 'Which graph do you want to view?',
      emptySelection: 'Not selected',
      dataYearMonth: 'Year / Month',
      dataYear: 'Data Year',
      previousMonth: 'Previous',
      nextMonth: 'Next',
      selectYear: 'Select year',
      selectMonth: 'Select month',
      yearPlaceholder: '----',
      monthPlaceholder: '--',
      yearSuffix: '',
      monthSuffix: '',
      locationLabel: 'Location',
      selectLocation: 'Select location',
      locationEmpty: 'No location selected',
      cameraPlacementButton: 'Camera map',
      cameraImageAlt: 'Camera installation locations',
      closeModal: 'Close',
    },
    share: {
      title: 'Share dashboard',
      text: '{location} data for {month}/{year}',
      button: 'Share',
      tooltipNoData: 'No data selected',
      tooltipCopy: 'Copy URL',
      copied: 'URL copied to clipboard',
    },
    aiPrompt: {
      sectionTitle: 'Generative AI',
      sectionLead:
        'Build a short prompt from this chart and local context, then paste it into your AI assistant. It is meant as a base layer: your AI may add trustworthy web context about Takayama and help you read the numbers and plan next steps.',
      openButton: 'Create & copy prompt',
      modalTitle: 'Ask your AI assistant',
      modalIntro:
        'We combined what you see on this chart with a little local context into one easy-to-read message. Paste it into your usual AI assistant as a starting point: it may search the web for trustworthy Takayama context and help you understand what the numbers mean. If anything looks off, feel free to edit it here before copying.',
      copyAreaExplain: 'Tap “Copy this text” to copy everything in the box below at once.',
      copy: 'Copy this text',
      promptAriaLabel: 'Draft message for your AI assistant',
      copied: 'Copied to clipboard',
      copyFailed: 'Copy failed',
      unsupported: 'Not available for this view yet.',
    },
    today: {
      overview: '{date} Overview',
      todayLabel: 'Today',
      todayData: "Today's data",
      noData: 'Data is not available yet',
      weekend: 'Weekend',
      weekday: 'Weekday',
      congestionLevel: 'Congestion Level {level}',
      weekdaySuffix: '',
    },
    common: {
      fetchError: 'Failed to fetch data.',
      loadingData: 'Loading data...',
      selectLocationFirst: 'Please select a location first.',
    },
    legend: {
      titleCalendar: 'Congestion legend (top: date, bottom: level):',
      titleDefault: 'Congestion legend:',
      peopleAmount: 'How to read how many people',
      readGuideLead: 'A bigger number means more people',
      bandLow: 'Few',
      bandMid: 'Average',
      bandHigh: 'Crowded',
      bandRange: '{from}–{to}',
      dayLabel: 'Date',
      noData: 'No data',
      calcNote: 'Average values are calculated using only time slots with at least one pedestrian.',
      weatherInfo: 'Weather:',
      weatherPlacement: 'Shown at the bottom of each cell',
    },
    todayDetails: {
      titleSuffix: ' congestion overview',
      thisYear: 'This year',
      lastYear: 'Last year',
    },
    adminThresholds: {
      title: 'Congestion thresholds',
      back: 'Back to dashboard',
      uiJa: 'Labels: Japanese',
      uiEn: 'English UI',
      showSlug: 'Show location codes',
      layoutOverview: 'All locations',
      layoutFocus: 'Single location',
      secretLabel: 'CRON_SECRET',
      authBtn: 'Enter admin key',
      reauthBtn: 'Change admin key',
      authed: 'Authenticated',
      needAuth: 'Please enter admin key first',
      loadBtn: 'Load thresholds',
      reloadBtn: 'Reload thresholds',
      dateLabel: 'Preview date',
      monthLabel: 'Preview month',
      monthDayLabel: 'Day in month',
      actionGroupLabel: 'Graph type',
      seedBtn: 'Reset to default values',
      seedBtnHelp: 'For the selected graph type, fill missing locations with built-in defaults',
      seedConfirmMissing: 'Reset unset locations for “{group}” to default values?',
      seedConfirmOverwrite: 'Overwrite all locations for “{group}” with default values?',
      seedOk: 'Reset done: created {created}, updated {updated}, skipped {skipped}',
      builtinHint: 'Built-in {min}–{max}',
      applyBuiltin: 'Use built-in',
      batchBtn: 'Recalculate prediction ({n} sites)',
      batchAllBtn: 'Recalculate all sites',
      batchRunning: 'Running predictions…',
      batchBtnHelp: 'After saving Prediction (dti-shared) thresholds, rerun the batch to refresh count forecasts. Congestion display updates on save without batch.',
      batchAllBtnHelp: 'Regenerates prediction data for every location (slow)',
      batchNoTargets: 'No sites queued. Save prediction thresholds or edit values under the Prediction group.',
      batchConfirmChanged: 'Recalculate prediction for these {n} sites?\n{places}\n\nContinue?',
      batchConfirmAll:
        'Run the prediction batch for all locations?\n· May take several minutes\n· Preview will refresh automatically when finished\n\nContinue?',
      batchStarted: 'Started prediction batch for {n} sites ({batchId})',
      batchDone: 'Batch done: {ok} succeeded, {fail} failed (of {total})',
      previewLoading: 'Loading preview…',
      previewStatus: '{ok} loaded, {fail} failed',
      stripCurrent: 'Congestion preview (current thresholds)',
      stripBeforeEdit: 'Before edit (live production)',
      stripAfterEdit: 'After edit (applies when saved)',
      compareHintShort: 'Comparing thresholds {before} → {after} while editing.',
      previewThresholdRange: '(thresholds {range})',
      chartCurrent: 'Current',
      chartBeforeEdit: 'Before',
      chartAfterEdit: 'After',
      unsaved: 'Unsaved',
      hintShort:
        'After login, changing thresholds or dates auto-refreshes the preview. Save to apply to production.',
      listTitle: 'List',
      placesUnit: ' sites',
      placeCol: 'Location',
      minPeople: 'Min (pedestrians)',
      midPeople: 'Mid (optional; used for bin boundaries when set)',
      maxPeople: 'Max (pedestrians)',
      dbCol: 'DB',
      save: 'Save',
      history: 'History',
      memoLabel: 'Save note (optional, shared)',
      miniLineTitle: 'Mini line charts (all locations)',
      previewPlace: 'Detail preview location',
      emptyHint: 'Authenticate, then Load thresholds',
      emptyFetchHint: 'Load thresholds to show the preview automatically',
      emptyDetailHint: 'Select a location and fetch to preview',
      previewTitle: 'Dashboard-style preview (HourlyCell, 7–22)',
      apiHeatRow: 'Heatmap-style row (time)',
      draftHeatRow: 'Heatmap-style row (time, after edit)',
      expandedLineTitle: 'Line chart (enlarged, one location)',
      chartApi: 'Public API',
      chartDraft: 'Form preview',
      historyTitle: 'History',
      close: 'Close',
      apply: 'Apply',
      noneHistory: 'None',
      errMinMax: 'Enter numeric min and max',
      errMinMaxNamed: '{min} and {max} must be numeric',
      errOrder: 'Min must be less than max',
      errOrderNamed: '{min} must be less than {max}',
      errMiddle: 'Mid must be between min and max',
      errMiddleNamed: '{mid} must be between {min} and {max}',
      loadedOk: 'Loaded {n} locations',
      savedOk: 'Saved {place}',
      fetchOk: 'Fetched OK {ok} / failed {fail} ({label})',
      batchOk: 'Batch done: failed {ng}/{total}',
      historyApplied: 'History #{id} applied to {place} (Save to commit)',
      noPrediction: 'No prediction',
      matrixTitle: 'Thresholds by location and graph',
      viewMatrix: 'Overview',
      viewEdit: 'Edit',
      editPanelTitle: 'Editing graph type',
      editPanelOpenGroup: 'Change graph type via the “Graph type” dropdown in the header.',
      matrixEditBtn: 'Edit',
      reloadMatrix: 'Reload matrix',
      matrixEmpty: 'Authenticate to load the matrix',
      matrixCellDb: 'DB: {min}–{max}',
      matrixCellFallback: 'Effective (via {group}): {min}–{max}',
      matrixCellBuiltin: 'Built-in: {min}–{max}',
      dbCurrentCol: 'DB current',
      dbNotSet: 'Not set',
      viaFallback: 'fallback',
      editingGroup: 'Editing: {group}',
      previewDateFallback: 'Showing date: {date} (no data on selected day)',
      previewNotFetched: 'Load thresholds, or run Recalculate predictions if no data exists',
      graphTypeCol: 'Graph type',
      thresholdRangeCol: 'Min–max',
      builtinShort: 'built-in',
      loginBtn: 'Admin login',
      loginApply: 'Log in',
      logoutBtn: 'Log out',
      previewUsesPrediction:
        'Right preview uses the prediction API hourly view (same heatmap_date_time thresholds as dti_*). Saves apply immediately to production.',
      previewUsesProduction:
        'Right preview uses the same graphs as production (/api/get-graph) for the selected graph type.',
      previewProductionTitle: 'Production preview: {group}',
      previewOverviewProductionHint: 'Mini charts appear only when editing Prediction. Use the detail preview below for other graph types.',
      matrixHint: 'Expand a location to see thresholds per graph. Use “Edit” on a row to open the input form. Preview location syncs on the right.',
      splitDragHint: 'Drag the divider to resize panels',
    },
    footer: {
      noticeTitle: 'Notes on data usage',
      noticeLeadBefore: 'This page is created from Takayama City open data (',
      noticeLeadLink: 'Pedestrian Traffic Survey Data in Downtown Areas',
      noticeLeadConnector: ', ',
      noticeLeadLinkForeigners: 'Foreign Tourist Accommodation Statistics',
      noticeLeadAfter: '). We are not responsible for any loss resulting from the use of this page.',
      noticeBody: 'The data is collected automatically by cameras and may differ from actual conditions. Please check official websites or facilities directly for the latest and most accurate information.',
      noticeTermsBefore: 'For details, please see the ',
      noticeTermsLink: 'Terms of Use and Privacy Policy',
      noticeTermsAfter: '.',
      foreignerSourceLabel: 'Source:',
      foreignerSourceName: 'Takayama City Foreign Tourist Accommodation Statistics',
    },
  },
};

const ACTION_LABELS = {
  today_details: {
    ja: { label: '今日について詳しく知りたい', shortLabel: '今日について詳しく知る' },
    en: { label: 'Learn about today', shortLabel: 'Learn about today' },
  },
  cal_holiday: {
    ja: { label: '店舗の定休日を検討したい', shortLabel: '店舗の定休日を検討' },
    en: { label: 'Consider store closing days', shortLabel: 'Store closing days' },
  },
  cal_shoping_holiday: {
    ja: { label: '商店街の定休日を検討したい', shortLabel: '商店街の定休日を検討' },
    en: { label: 'Consider district-wide closing days', shortLabel: 'District closing days' },
  },
  cal_long_holiday: {
    ja: { label: '長期休暇のタイミングを検討したい', shortLabel: '長期休暇のタイミングを検討' },
    en: { label: 'Plan extended holidays', shortLabel: 'Extended holidays' },
  },
  cal_event: {
    ja: { label: 'イベントの開催日程を検討したい', shortLabel: 'イベントの開催日程を検討' },
    en: { label: 'Plan event dates', shortLabel: 'Event dates' },
  },
  cal_training: {
    ja: { label: '研修のタイミングを検討したい', shortLabel: '研修のタイミングを検討' },
    en: { label: 'Plan training schedule', shortLabel: 'Training schedule' },
  },
  dti_event_time: {
    ja: { label: 'イベントの開催時刻を検討したい', shortLabel: 'イベントの開催時刻を検討' },
    en: { label: 'Plan event timing', shortLabel: 'Event timing' },
  },
  wti_shift: {
    ja: { label: 'アルバイトのシフトを検討したい', shortLabel: 'アルバイトのシフトを検討' },
    en: { label: 'Adjust staff shifts', shortLabel: 'Staff shifts' },
  },
  dti_open_hour: {
    ja: { label: 'お店の営業時刻を検討したい', shortLabel: 'お店の営業時刻を検討' },
    en: { label: 'Adjust business hours', shortLabel: 'Business hours' },
  },
  dti_shoping_open_hour: {
    ja: { label: '商店街の営業時刻を検討したい', shortLabel: '商店街の営業時刻を検討' },
    en: { label: 'Adjust district hours', shortLabel: 'District hours' },
  },
  event_effect: {
    ja: { label: 'イベントの効果を見る', shortLabel: 'イベントの効果を見る' },
    en: { label: 'Evaluate event effectiveness', shortLabel: 'Event effectiveness' },
  },
  cal_cog: {
    ja: { label: 'カレンダー形式の混雑度が見たい', shortLabel: 'カレンダー形式混雑度を見る' },
    en: { label: 'View calendar format', shortLabel: 'Calendar format' },
  },
  dti_cog: {
    ja: { label: '日時形式の混雑度が見たい', shortLabel: '日時形式混雑度を見る' },
    en: { label: 'View hourly heatmap', shortLabel: 'Hourly heatmap' },
  },
  wti_cog: {
    ja: { label: '曜日形式の混雑度が見たい', shortLabel: '曜日形式混雑度を見る' },
    en: { label: 'View day-of-week heatmap', shortLabel: 'Day-of-week heatmap' },
  },
  month_trend: {
    ja: { label: '月ごとの傾向を見たい', shortLabel: '月ごとの傾向を見る' },
    en: { label: 'View monthly trends', shortLabel: 'Monthly trends' },
  },
  week_trend: {
    ja: { label: '週ごとの傾向を見たい', shortLabel: '週ごとの傾向を見る' },
    en: { label: 'View weekly trends', shortLabel: 'Weekly trends' },
  },
  foreigners_distribution: {
    ja: { label: '外国人の分布を見たい', shortLabel: '外国人分布を見る' },
    en: { label: 'View foreign visitor distribution', shortLabel: 'Foreign visitor distribution' },
  },
  foreigners_yearly_distribution: {
    ja: { label: '年を通した外国人の分布を見たい', shortLabel: '外国人分布(年)を見る' },
    en: { label: 'View yearly foreign visitor distribution', shortLabel: 'Foreign distribution (yearly)' },
  },
};

const LOCATION_LABELS = {
  'old-town': { ja: '古い町並', en: 'Old Town' },
  station: { ja: '駅前', en: 'Takayama Station' },
  gyouzinbashi: { ja: '行神橋', en: 'Gyojinbashi Bridge' },
  omotesando: { ja: '表参道', en: 'Omotesando' },
  yottekan: { ja: 'よって館しもちょう', en: 'Yottekanshimocho' },
  honmachi4: { ja: '本町4丁目商店街', en: 'Honmachi 4th Shopping Street' },
  honmachi3: { ja: '本町3丁目商店街', en: 'Honmachi 3rd Shopping Street' },
  honmachi2: { ja: '本町2丁目商店街', en: 'Honmachi 2nd Shopping Street' },
  kokubunjidori: { ja: '国分寺通り 第二商店街', en: 'Kokubunji-dori 2nd Shopping Street' },
  yasukawadori: { ja: 'やすかわ通り商店街', en: 'Yasukawa-dori Shopping Street' },
  jinnya: { ja: '高山陣屋前交差点', en: 'Takayama Jinya Intersection' },
  nakabashi: { ja: '中橋', en: 'Nakabashi Bridge' },
};

const COUNTRY_LABELS = {
  台湾: 'Taiwan',
  イギリス: 'United Kingdom',
  アメリカ: 'United States',
  中国: 'China',
  韓国: 'South Korea',
  香港: 'Hong Kong',
  タイ: 'Thailand',
  フランス: 'France',
  ドイツ: 'Germany',
  オーストラリア: 'Australia',
  カナダ: 'Canada',
  シンガポール: 'Singapore',
  マレーシア: 'Malaysia',
  フィリピン: 'Philippines',
  インドネシア: 'Indonesia',
  ベトナム: 'Vietnam',
  スペイン: 'Spain',
  イタリア: 'Italy',
  ロシア: 'Russia',
  インド: 'India',
  未分類: 'Unclassified',
  不明: 'Unknown',
};

export const detectLanguageFromPathname = (pathname = '') => {
  if (pathname === '/en' || pathname.startsWith('/en/')) return 'en';
  return 'ja';
};

export const translate = (language, key, params = {}) => {
  const segments = key.split('.');
  const source = MESSAGES[language] || MESSAGES.ja;
  const fallback = MESSAGES.ja;

  const resolve = (obj) => segments.reduce((acc, segment) => acc?.[segment], obj);
  let template = resolve(source) ?? resolve(fallback) ?? key;

  if (typeof template !== 'string') return key;

  Object.entries(params).forEach(([name, value]) => {
    template = template.replaceAll(`{${name}}`, String(value));
  });

  return template;
};

export const getActionLabel = (actionKey, language = 'ja') => {
  const labels = ACTION_LABELS[actionKey];
  if (!labels) return { label: actionKey, shortLabel: actionKey };
  return labels[language] || labels.ja;
};

export const getLocationLabel = (locationKey, language = 'ja') => {
  const labels = LOCATION_LABELS[locationKey];
  if (!labels) return locationKey;
  return labels[language] || labels.ja;
};

export const getCountryLabel = (countryLabel, language = 'ja') => {
  if (language !== 'en') return countryLabel;
  if (!countryLabel) return countryLabel;
  return countryLabel
    .split(':')
    .map((part) => COUNTRY_LABELS[part] || part)
    .join(':');
};

import { getRouteBase, MEIDAISAI_PREFIX } from '../config/meidaisaiDemo';

export const stripLanguagePrefix = (pathname = '') => {
  let path = pathname || '/';
  if (path === MEIDAISAI_PREFIX) return '/';
  if (path.startsWith(`${MEIDAISAI_PREFIX}/`)) {
    path = path.slice(MEIDAISAI_PREFIX.length) || '/';
  }
  if (path === '/en') return '/';
  if (path.startsWith('/en/')) return path.slice(3);
  return path;
};

export const buildPathWithLanguage = (pathname = '/', language = 'ja', currentPathname = '') => {
  const routeBase = getRouteBase(currentPathname);
  const normalizedPath = stripLanguagePrefix(pathname);
  let path;
  if (language === 'en') {
    path = normalizedPath === '/' ? '/en/purpose' : `/en${normalizedPath}`;
  } else {
    path = normalizedPath === '/' ? '/purpose' : normalizedPath;
  }
  return `${routeBase}${path}`;
};
